/** @jsx jsx */
import { connect } from 'react-redux'
import { FsCore } from '../../types/fs-core'
import { jsx } from 'theme-ui'
import { Document } from '@contentful/rich-text-types'
import RichTextBlock from '../ev-rich-text-block'
import ImgixImg from '../helpers/imgix-image'
import { useEntity } from '../helpers/selectors'
import MultiStepForm from '../form'
import { brand } from '../../redux/app-selectors'

interface Props {
  variant: string
  sponsorshipType: string
  image: object
  header: Document
  content: Document
  footer: Document
  form: object
  useContainer: boolean
  brand: 'money' | 'uswitch'
}

const uswitchRichTextBlockStyles = {
  h4: {
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '24px',
  },
  p: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
  },
  li: {
    margin: '0',
    '&::before': {
      color: 'inherit',
    },
  },
}

const moneyRichTextBlockStyles = {
  h4: {
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '24px',
  },
  p: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
  },
  li: {
    margin: '0',
    '&::before': {
      color: 'inherit',
    },
  },
}

const uswitchRichTextBlockFooterStyle = {
  p: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    marginBottom: '16px',
  },
}

const TenancyModule: React.FC<Props> = (props) => {
  const { sponsorshipType, image, header, content, footer, form, brand } = props
  const imageEntity = useEntity(image)
  const formEntity = useEntity(form)

  return (
    <div className='tenancy-module'>
      <h3 className='tenancy-module__mobile__sponsored'>{sponsorshipType}</h3>

      <div className='tenancy-module__info'>
        <div className='tenancy-module__info__image'>
          <ImgixImg
            src={imageEntity?.file?.url}
            alt={imageEntity?.title}
            sx={{
              minWidth: '170px',
              display: 'block',
              marginLeft: 'auto',
              marginRight: ['auto', 0],
            }}
          />
        </div>

        <div className='tenancy-module__info__text'>
          <h3 className='tenancy-module__info__text__desktop__sponsored'>{sponsorshipType}</h3>
          <div className='tenancy-module__info__text__header'>
            <RichTextBlock
              {...header}
              style={brand === 'money' ? moneyRichTextBlockStyles : uswitchRichTextBlockStyles}
            />
          </div>
          <div className='tenancy-module__info__text__content'>
            <RichTextBlock
              {...content}
              style={brand === 'money' ? moneyRichTextBlockStyles : uswitchRichTextBlockStyles}
            />
          </div>
          <RichTextBlock
            className='tenancy-module__info__text__footer'
            {...footer}
            style={uswitchRichTextBlockFooterStyle}
          />
        </div>
        <div className='tenancy-module__info__form'>
          {form && <MultiStepForm {...formEntity} target={'_blank'} />}
        </div>
      </div>
    </div>
  )
}

export default connect((state: FsCore.State, props: any) => {
  return {
    ...props,
    brand: brand(state),
  }
})(TenancyModule)
